import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
export const createFakeUnauthorizedResponse = () => {
  const err = new Error('Unauthorized');

  _Object$assign(err, {
    data: {
      userFacingError: 'Invalid session token.'
    },
    body: {
      errors: [{
        detail: 'Invalid session token.',
        title: 'unauthorized'
      }]
    },
    response: {
      ok: false,
      status: 401
    }
  });

  return err;
};
export const createFakeSuccessfulLogoutResponse = () => ({
  response: {
    ok: true,
    status: 204
  }
});